<template>

    <div class="settings">
        <HeaderUI/>
        <main class="page-main">
            <div class="page-container page-container--narrow">
                <div class="page-header">
                    <div>
                        <h1 class="page-title">Настройки</h1>
                        <p class="page-description">Информация об аккаунте</p>
                    </div>
                </div>

                <ErrorAuthView :is-auth="isAuth"/>

                <section v-if="isAuth" class="card">
                    <div class="card-header">
                        <div class="card-title">Профиль</div>
                    </div>
                    <div class="card-body">
                        <div class="profile-id">
                            <div class="profile-avatar">{{ userInitial }}</div>
                            <div>
                                <div class="profile-name">{{ login }}</div>
                                <div class="profile-sub">
                                    <AppIcon name="hash" class="profile-sub-icon"/>
                                    ID пользователя: {{ user_id }}
                                </div>
                            </div>
                        </div>
                        <div class="profile-row">
                            <div class="profile-label">Логин</div>
                            <div>{{ login }}</div>
                        </div>
                        <div class="profile-row">
                            <div class="profile-label">ID пользователя</div>
                            <div>{{ user_id }}</div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <ButtonUI :title="'Выйти из аккаунта'" :icon="'remove'" variant="outline" @click="doLogout()"/>
                    </div>
                </section>
            </div>
        </main>
    </div>

</template>


<script>

import HeaderUI from '../components/HeaderUI.vue'
import ErrorAuthView from '@/components/ErrorAuthView.vue';
import ButtonUI from '@/components/ButtonUI.vue';
import AppIcon from '@/components/AppIcon.vue';

import { checkAuth, validateAuth, logout } from '@/auth/auth'


export default {
    name: 'SettingsView',

    components: {
        HeaderUI,
        ErrorAuthView,
        ButtonUI,
        AppIcon
    },

    created() {
        this.isAuth = checkAuth();
        this.login = localStorage.getItem('login');
        this.user_id = localStorage.getItem('user_id');

        // серверная проверка: если токен отозван/просрочен - выходим
        validateAuth().then((valid) => {
            if (!valid && this.isAuth) {
                logout();
                this.isAuth = false;
            }
        })
    },

    data() {
        return {
            isAuth: false,
            login: null,
            user_id: null,
        }
    },

    computed: {
        userInitial() {
            const name = this.login || '?';
            return name.charAt(0).toUpperCase();
        },
    },

    methods: {
        doLogout(){
            logout().then(() => {
                this.isAuth = false;
                this.$router.push('/');
            })
        }
    },
}

</script>


<style scoped>

.settings{
    width: 100%;
    min-height: 100vh;

    display: flex;
    flex-direction: column;
}

.page-container--narrow{
    max-width: 640px;
}

.profile-id{
    display: flex;
    align-items: center;
    gap: 14px;

    margin-bottom: 14px;
}

.profile-avatar{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    width: 46px;
    height: 46px;

    background: var(--primary);
    color: var(--primary-foreground);
    border-radius: 999px;

    font-size: 18px;
    font-weight: 600;
}

.profile-name{
    font-size: 16px;
    font-weight: 600;
}

.profile-sub{
    margin-top: 2px;

    display: inline-flex;
    align-items: center;
    gap: 4px;

    font-size: 13px;
    color: var(--muted-foreground);
}

.profile-sub-icon{
    width: 13px;
    height: 13px;
}

.profile-row{
    display: flex;
    gap: 12px;

    padding: 10px 0;

    font-size: 14px;
}

.profile-row + .profile-row{
    border-top: 1px solid var(--border);
}

.profile-label{
    width: 180px;
    flex-shrink: 0;

    color: var(--muted-foreground);
}

.card-footer{
    display: flex;
    justify-content: flex-end;
}

</style>
